export const EMAIL = 'takamagahara.stone@gmail.com'

export const Z_INDEX_NAVIGATION = 1
export const Z_INDEX_DRAWER = 2
export const Z_INDEX_PAGE_TRANSITION = 33
